import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";

const usePAExposuresTimeline = (sponsorObjectId = 0, rightsholderId = 0, parentTenantId = null) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const enabled = !!(startDate && endDate);

  let since, until;
  if (enabled) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: ["PA_EXPOSURES_TIMELINE", tenant.id, sponsorObjectId, rightsholderId, parentTenantId, startDate, endDate],
    queryFn: () => ApiService.getPlacementAnalysisExposuresTimeline({
      sponsorObjectId,
      rightsholderId,
      parentTenantId,
      since,
      until,
    }),
    select: (data) => data.data.graphs,
    enabled,
    placeholderData: { data: { graphs: [] } },
  });
};

export default usePAExposuresTimeline;
